import React, { FunctionComponent } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import Box from '@mui/material/Box'
import { ContestantWithBio } from '../../utils/interfaces'
import Text from '../../components/Text'
import AllContestants from '../CompetitionPage/AllContestants'
import { AddContestantButton } from './CompetitionDashboard'
import CompetitionCategoryDropdown from '../../components/CompetitionCategoryDropdown'
import competitionDashboardStore from '../../stores/competitionDashboardStore'
import { observer } from 'mobx-react-lite'


interface ICompetitionContestants {
  competitionTemplate?: number,
  deleteContestant: (contestantUsername: string) => void,
  evictContestant: (contestantUsername: string) => void,
  onClickContestantButton: () => void,
  saveContestant: (payload: ContestantWithBio) => Promise<void>,
  contestantLabel: string,
  savingContestant: boolean,
  contestants: ContestantWithBio[],
}

const CompetitionDashboardContestants: FunctionComponent<ICompetitionContestants> = ({
  saveContestant,
  evictContestant,
  contestantLabel,
  contestants,
  savingContestant,
  deleteContestant,
  competitionTemplate,
  onClickContestantButton,
}) => {
  return (
    <>
      <Box
        flexDirection='row'
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <CompetitionCategoryDropdown 
          categories={competitionDashboardStore.allCategories}
          selectedCategory={competitionDashboardStore.selectedCategory}
          onSelectCategory={category => competitionDashboardStore.setCompetitionCategory(category)}
        />
        <AddContestantButton
          variant="secondary"
          onClick={onClickContestantButton}>
          <FontAwesomeIcon icon={faPlus} />
          <Text variant="regular">Add New {contestantLabel}</Text>
        </AddContestantButton>
      </Box>
      <AllContestants
        competitionTemplate={competitionTemplate}
        deleteContestant={deleteContestant}
        evictContestant={evictContestant}
        saveContestant={saveContestant}
        savingContestant={savingContestant}
        contestants={contestants}
        variant="edit" />
    </>
  )
}

export default observer(CompetitionDashboardContestants)